import React from 'react';

function AlignmentBars({ 
  type, 
  chinPosition, 
  widowsPeakPosition,
  leftFacePosition,
  rightFacePosition,
  setIsDraggingChin,
  setIsDraggingWidowsPeak,
  setIsDraggingLeftFace,
  setIsDraggingRightFace
}) {
  if (type === 'horizontal-alignment') {
    return (
      <>
        {/* Widow's Peak Bar */}
        <div
          className="absolute left-0 right-0 flex items-center cursor-move"
          style={{ top: `${widowsPeakPosition}%`, transform: 'translateY(-50%)', touchAction: 'none' }}
          onMouseDown={() => setIsDraggingWidowsPeak(true)}
          onTouchStart={(e) => { e.preventDefault(); setIsDraggingWidowsPeak(true); }}
        >
          <div className="w-full h-0.5 bg-green-500 shadow-lg"></div>
          <div className="absolute -left-10 top-1/2 -translate-y-1/2 bg-green-600 text-white text-base font-semibold px-4 py-2 rounded-lg whitespace-nowrap shadow-lg">
            Widow's Peak
          </div>
        </div>
        
        {/* Chin Bar */}
        <div
          className="absolute left-0 right-0 flex items-center cursor-move"
          style={{ top: `${chinPosition}%`, transform: 'translateY(-50%)', touchAction: 'none' }}
          onMouseDown={() => setIsDraggingChin(true)}
          onTouchStart={(e) => { e.preventDefault(); setIsDraggingChin(true); }}
        >
          <div className="w-full h-0.5 bg-blue-500 shadow-lg"></div>
          <div className="absolute -right-2 top-1/2 -translate-y-1/2 bg-blue-600 text-white text-base font-semibold px-4 py-2 rounded-lg shadow-lg">
            Chin
          </div>
        </div>
      </>
    );
  }

  if (type === 'vertical-alignment') {
    return (
      <>
        {/* Left Face Bar */}
        <div
          className="absolute top-0 bottom-0 flex justify-center cursor-move"
          style={{ left: `${leftFacePosition}%`, transform: 'translateX(-50%)', touchAction: 'none' }}
          onMouseDown={() => setIsDraggingLeftFace(true)}
          onTouchStart={(e) => { e.preventDefault(); setIsDraggingLeftFace(true); }}
        >
          <div className="w-0.5 h-full bg-purple-500 shadow-lg"></div>
          <div className="absolute top-2 left-1/2 -translate-x-1/2 bg-purple-600 text-white text-base font-semibold px-4 py-2 rounded-lg whitespace-nowrap shadow-lg">
            Left
          </div>
        </div>
        
        {/* Right Face Bar */}
        <div
          className="absolute top-0 bottom-0 flex justify-center cursor-move"
          style={{ left: `${rightFacePosition}%`, transform: 'translateX(-50%)', touchAction: 'none' }}
          onMouseDown={() => setIsDraggingRightFace(true)}
          onTouchStart={(e) => { e.preventDefault(); setIsDraggingRightFace(true); }}
        >
          <div className="w-0.5 h-full bg-orange-500 shadow-lg"></div>
          <div className="absolute bottom-2 left-1/2 -translate-x-1/2 bg-orange-600 text-white text-base font-semibold px-4 py-2 rounded-lg whitespace-nowrap shadow-lg">
            Right
          </div>
        </div>
      </>
    );
  }

  return null;
}

export default AlignmentBars;
